import styled from "styled-components"
import { motion } from "motion/react"
import { SvgComponent } from "@/components/base/Svg"
import ButtonRegular from "@/components/composite/ButtonRegular/main"
import { ImageComponent } from "@/components/base/Image"

export const MotionDiv = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

export const FixedBox = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`
export const CenterBox = styled.div`
    height: 100%;
    width: var(--app-max-width);
    align-self: center;
    position: relative;
`

export const FrameSvg = styled(ImageComponent("pages/BlindBox/frame.webp"))`
    width: auto;
    height: 56rem;
`
export const Frame = styled(motion.div)`
    position: -webkit-sticky;
    position: sticky;
    z-index: 100;
    bottom: 70rem;
    left: 100%;
    display: flex;
    width: 45rem;
    height: 56rem;
    margin-bottom: -56rem;
    cursor: pointer;
`
export const ReceiveSvg = styled(ImageComponent("pages/BlindBox/receive_button.webp"))`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
`
export const CancelSvg = styled(SvgComponent("pages/BlindBox/cancel.svg"))`
    width: 32rem;
    height: 32rem;
    margin-top: 15rem;
    cursor: pointer;
`

export const AnimationModal = styled(motion.div)`
    position: absolute;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
export const Container = styled(motion.div)`
    user-select: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
export const Title = styled.div`
    font-family: "Jersey 25";
    font-size: 24rem;
    text-align: center;
    text-transform: uppercase;
    color: #fff;
    background: linear-gradient(180deg, #fff6d6 0%, #ffacd7 87.5%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    text-shadow: 0 0 0.01px rgba(0, 0, 0, 0);
    transform: translateZ(0);
    backface-visibility: hidden;
    will-change: transform;
    span {
        background: linear-gradient(180deg, #ffd7f1 0%, #ff05aa 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
    }
`
export const Button = styled.div`
    font-family: "Gilroy";
    font-size: 16rem;
    font-weight: bold;
    text-align: center;
    width: 202rem;
    height: 56rem;
    position: relative;
    margin-top: 245rem;
    margin-bottom: 16rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
    color: #fff;
    border-radius: 56rem;
`
export const Invalid = styled.div`
    font-family: "Gilroy";
    font-size: 12rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    gap: 5rem;
`
